<template>
  <page-outline :title="$t('common.add_contact')"
    iconFA="address-book" returnUrl="/contacts/">

    <template slot="pageContent">
      <form-accordion :title="$t('common.contact_ids')">
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="typeContact"
              type="radio" name="inlineDefaultRadiosExample"
              id="defaultInline1" class="custom-control-input"
              value="1">
            </input>
            <label class="custom-control-label" for="defaultInline1">
              {{ $t('common.indiv') }}
            </label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="typeContact"
              type="radio" name="inlineDefaultRadiosExample"
              id="defaultInline2" class="custom-control-input"
              value="2">
            </input>
            <label class="custom-control-label" for="defaultInline2">
              {{ $t('common.cmpny') }}
            </label>
          </div>
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :idLabel="$t('common.nme')"
              :placeholderValue="$t('common.nme')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="label" isMandatory
              :idLabel="$t('common.als')"
              :placeholderValue="$t('common.als')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group typeInd" v-if="typeContact === '1'"
          @click="hideBlock($event)">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :idLabel="$t('common.eml')"
              :placeholderValue="$t('common.eml')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group typeCom" v-else
          @click="hideBlock($event)">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :idLabel="$t('common.srn')"
              :placeholderValue="$t('common.srn')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>

      <form-accordion :title="$t('common.formsSubTitle.bank_info')">
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
             {{ $t('common.act') }}
             <span class="color-red">* </span>
            </label>
            <!--<div class="col-sm-4 showSmallScreenOnly form-group" :class='colorBottomButton'>
             <div @click="countriesPicker($event)" class="button button-round buttonAccordionForm">
               {{ $t('common.slct') }}
             </div>
            </div>
            <div class="col-sm-12 showSmallScreenOnly">
             <input
              @click="countriesPicker($event)"
              class="form-control"
              id="ListCountry"
              type="text"
              v-model="zoneCode"
              :placeholder="benef_Selectazone"
              readonly>
             </input>
            </div> -->
            <select class="form-control" id="sel4" v-model="zone" readonly>
              <option v-for="country in countries" :key="country.id"
                :value="country"
                :disabled="country.disabled"
                :selected="country.selected">
                {{ $t('zoneCodes.' + country.label) }}
              </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group"
            v-for="accountLabel in zone.accountLabel" :key="accountLabel">
            <form-write-group-label-input v-model="zone.values[accountLabel]" isMandatory
              :idLabel="$t(accountLabel)"
              :placeholderValue="$i18n.t(accountLabel)">
            </form-write-group-label-input>
          </b-col>
        </b-row>


        <div v-if="this.$engine.user.currentService.id === '2'">
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="mandatId"
                :idLabel="$t('bank_accounts.mandat_id')"
                :placeholderValue="$i18n.t('bank_accounts.mandat_id')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="mandatDate"
                inputType="date"
                :idLabel="$t('bank_accounts.mandat_date')"
                :placeholderValue="$i18n.t('bank_accounts.mandat_date')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </div>
      </form-accordion>

      <hr/>

      <form-accordion :title="$t('common.formsSubTitle.extra_info')">
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="phoneNumber"
              :idLabel="$t('common.phn')" :placeholderValue="benef_PhoneNumber">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="address"
              :idLabel="$t('common.adrs')" :placeholderValue="benef_Address">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="city"
              :idLabel="$t('common.cty')" :placeholderValue="benef_City">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="zipCode"
              :idLabel="$t('common.zp_code')" :placeholderValue="benef_ZipCode">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="country"
              :idLabel="$t('common.ctry')" :placeholderValue="benef_Country">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9" class="form-group">
          <f7-button
            class="milkyBlockBlack button-action"
            @click="addContact">
            <f7-icon fa="save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
  <!-- </f7-page> -->
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {createForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'AddContact',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      isSmartphone: false,
      identifier: '',
      name: '',
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '1',
      zone: {
        id: 0,
        label: 'zoneCodes.slct_zone',
        disabled: true,
        selected: true
      },
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    let that = this
    this.$i18n.t('common.add_item', {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.benef_name = this.$i18n.t('common.nme')
    this.benef_alias = this.$i18n.t('common.als')
    this.benef_alias = this.$i18n.t('common.als')
    this.benef_EmailAddress = this.$i18n.t('common.eml_adrs')
    this.benef_SIREN = this.$i18n.t('common.srn')
    this.benef_SortCode = this.$i18n.t('common.srt_code')
    this.benef_AccountNumber = this.$i18n.t('common.act_nbr')
    this.benef_PhoneNumber = this.$i18n.t('common.phn_nbr')
    this.benef_Address = this.$i18n.t('common.adrs')
    this.benef_City = this.$i18n.t('common.cty')
    this.benef_ZipCode = this.$i18n.t('common.zp_code')
    this.benef_Country = this.$i18n.t('common.ctry')
    this.benef_Selectazone = this.$i18n.t('zoneCodes.slct_zone')
    that.countries = this.$engine.bankAccounts.getZoneCode()
    that.zoneCode = ''
    let label = []
    // Ajout des labels pour le picker de la version mobile
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = that.$engine.bankAccounts.getZoneData(p.value[0])
      }
    })
  },
  computed: {
    depositExecutionDateColor () {
      return (this.depositExecutionDate === '' || this.depositExecutionDate === 'Invalid date') && this.sendPaymentsClicked
    }
  },
  methods: {
    addContact () {
      let that = this

      if (that.name.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      if (that.label.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }
      if (this.identifier.length > 0 && this.typeContact === '1') {
        if (validateEmail(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.chng_the_eml_to_vld_frmt'),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.eml_adrs')})
          )
          return
        }
      } else if (this.identifier.length === 0 && this.typeContact === '1') {
        this.$f7.alert('',
          this.$t('errors.miss_email'))
        return
      }
      if (this.identifier.length > 0 && this.typeContact === '2') {
        if (validateSIREN(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.srn')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.srn')})
          )
          return
        }
      } else if (this.identifier.length === 0 && this.typeContact === '2') {
        this.$f7.alert('',
          this.$t('errors.missing_label',
              {invaliddata: this.$t('common.srn')}))
        return
      }
      if (this.zone.accountNumberField == null) {
        this.$f7.alert('',
            this.$i18n.t('errors.miss_zone')
        )
      }
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.accountLabel && this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t(''),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        } else {
          // Account zone is mandatory
          this.$f7.alert(
              this.$i18n.t('errors.please_enter_mandatory',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
              this.$i18n.t('errors.missing_label',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
          )
          return
        }
      }

      if (this.phoneNumber.length > 0) {
        if (validatePhoneNumber(this.phoneNumber.replaceAll(' ', '').replaceAll('.', '')) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.phn_nbr')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.phn_nbr')})
          )
          return
        }
      }
      /* TLV 18/03/2020
      * Création d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit contact
      // that.$f7.showPreloader('Adding contact')
      this.$engine.contacts.create({
        identifier: this.identifier,
        name: this.name,
        iban: localIban,
        label: this.label,
        phoneNumber: this.phoneNumber,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        typeContact: this.typeContact,
        zoneCode: this.zone.label
      })
      .then(() => {
        that.$f7.hidePreloader()
        that.$bus.$emit('refresh-cache-contacts')
        this.$f7.modal({
          title: this.$i18n.t('success.added_success', {data: this.$i18n.t('common.contact_label')}),
          text: '<span class="preloader"></span>'
        })

        setTimeout(function () {
          that.$f7.closeModal()
          that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        that.$f7.hidePreloader()
        this.handleError(err) // mixins errorHandlerMixins
      })

      that.$bus.$emit('refresh-cache-contacts')
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('typeInd')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
        } else {
          that.Dom7($event.target).next().hide()
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
        } else {
          that.Dom7($event.target).parent().next().hide()
        }
      }
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CMAddContact.vue?d87c8436